// The /cart/addCart payload for a product shown on a card, whatever its type
// (Seller, Dropshipping In, Dropshipping Out): every card builds it here so
// two cards never pick a different variant/image for the same product.
// Listings ship a trimmed filterProduct (first variants only), so the variant
// is a best effort: the server keeps it when it belongs to the product, else
// falls back to the product's best-stocked variant (addCart, server_elakay).
import { getProductPrimaryImage } from '../includes/auth/elakay-utils';

export const sortVariantsByStock = (product) =>
  [...(Array.isArray(product?.filterProduct) ? product.filterProduct : [])]
    .sort((a, b) => (Number(b?.quantity) || 0) - (Number(a?.quantity) || 0));

const idOf = (value) => value?._id || value || null;

export const buildCartItemFromProduct = (product, {
  color = '',
  urlImg = '',
  categoryID = null,
  filterProduct = null,
  count = 1,
} = {}) => {
  const variants = sortVariantsByStock(product);
  const variant = color ? variants.find((v) => v?.filter?.color === color) : variants[0];
  return {
    count: Math.max(1, Number(count) || 1),
    categoryID: idOf(categoryID) || idOf(product?.categoriesID?.[0]?.catID) || null,
    productID: product?._id,
    productOrner: idOf(product?.owner),
    urlImg: urlImg || getProductPrimaryImage(product) || '',
    filterProduct: idOf(filterProduct) || variant?._id || null,
  };
};

// Server refusal codes of /cart/addCart -> short text for the card icon.
export const addToCartErrorKey = (code) => ({
  LOCAL_SELLING_INELIGIBLE: ['h_atc_err_local', 'Not available at your address'],
  PRODUCT_DELETED: ['h_atc_err_gone', 'This product is no longer available'],
  CJ_PRODUCT_REMOVED: ['h_atc_err_gone', 'This product is no longer available'],
  PRODUCT_UNAVAILABLE: ['h_atc_err_gone', 'This product is no longer available'],
  PRODUCT_NOT_PURCHASABLE: ['h_atc_err_not_purchasable', 'This product cannot be added to the cart'],
}[code] || ['h_atc_err_generic', 'Could not add to cart. Please try again.']);
